import React from "react";

import { templates } from "@reactivated";

import { MultiProductWriteReviewSSR } from "../apps/reviews/MultiProductWriteReviewSSR";

export const Template = (
    props: templates.MultiProductWriteReviewFormTemplate,
): React.JSX.Element => {
    return <MultiProductWriteReviewSSR {...props} />;
};
